import { useEffect, useState } from "react";
import { onAuthStateChanged, type User as FirebaseUser } from "firebase/auth";
import { auth } from "@/lib/firebase";

export type AuthState = { user: FirebaseUser | null; loading: boolean };

export function useAuth(): AuthState {
  const [user, setUser] = useState<FirebaseUser | null>(auth.currentUser ?? null);
  const [loading, setLoading] = useState<boolean>(auth.currentUser == null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return { user, loading };
}

export function useCurrentUser(): FirebaseUser | null {
  const { user } = useAuth();
  return user;
}

export default useAuth;
